import * as React from "react";
 
// importing material UI components
import { useState } from 'react';
import MarketingLogsTable from './MarketingLogsTable';
import Container from '@mui/material/Container';
import {
  Box,
  Grid,
  Typography
} from '@mui/material';

const MarketingLogs = (props) => { 
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: 20
  });
  const [lastSynced, setLastSynced] = useState(null);

  return (
    <div className="App">
      <Box sx={{width: "100%", bgcolor: ""}}>
        {/* <h2 className="heading-title">Broadcast Logs</h2> */}
        <Grid container alignItems="center" sx={{ mb: 2 }}>
          
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', px: 1 }}>
            {lastSynced && (
              <Typography 
                variant="body2" 
                gutterBottom
                sx={{ fontSize: { xs: "12px", md: "14px" }, textAlign: "center" }}
                color="text.secondary"
              >
                Last chat received: {lastSynced} <i>(Logs may take up to 2 minutes to sync)</i>
              </Typography>
            )}
          </Grid>
        </Grid>

        {/* Marketing Logs Table Component */}
        <MarketingLogsTable 
          key={props.refreshKey} 
          controller={controller}
          setController={setController}
          lastSynced={lastSynced}
          setLastSynced={setLastSynced}
        />
      </Box>
    </div>
  );
}
export default MarketingLogs;
